import React, { useState, useEffect } from "react";
import styles from "./dropdown.module.scss";
import clsx from "clsx";
import LocalizedLink from "@components/LocalizedLink/localizedLink";

const Dropdown = ({ defaultValue, values, locale, pageSlug }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const close = () => setOpen(!open);
    if (open) {
      window.addEventListener('click', close);
    }

    return () => window.removeEventListener('click', close);
  }, [open]);

  return (
    <div className={clsx(styles.dropdown, open && styles.dropdownIsOpen)}>
      <div className={styles.dropdown__header}>
        <button
          className={styles.dropdown__selected}
          onClick={() => setOpen(!open)}
        >
          {defaultValue.title}
          <div
            className={clsx(
              styles.dropdown__arrow,
              styles.dropdown__arrowClicked
            )}
          />
        </button>
      </div>
      {open && (
        <ul className={styles.dropdown__list}>
          {Object.keys(values).map(key => (
            <li
              className={clsx(
                styles.dropdown__item,
                values[key].title === defaultValue.title && styles.dropdown__itemSelected
              )}
              key={values[key].title}
            >
              <LocalizedLink to={`/${pageSlug}/${key}`} locale={locale}>
                {values[key].title}
              </LocalizedLink>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
